import { STATE_RESET_TO_USERNAME_AUTH } from '../../constants/action_types';
export function resetToUsernameAuth() {
  return {
    type: STATE_RESET_TO_USERNAME_AUTH
  };
}